import 'arrive';
import YouTubePlayer from "youtube-player";

const initVideo = (wrap, { muted = false } = {}) => {
  if (wrap._videoInitialized) return;
  wrap._videoInitialized = true;

  const provider = wrap.dataset.videoProvider;
  const videoId  = wrap.dataset.videoId;
  const hosted   = wrap.dataset.videoHosted === "true";

  // YouTube
  if (provider === "youtube" && videoId) {
    let playerEl = wrap.querySelector(".yt-player");

    if (!playerEl) {
      playerEl = document.createElement("div");
      playerEl.className = "yt-player";
      wrap.appendChild(playerEl);
    }

    const player = YouTubePlayer(playerEl, {
      videoId: videoId,
      playerVars: {
        autoplay: 1,
        mute: muted ? 1 : 0,
        controls: 0,
        rel: 0,
        modestbranding: 1,
        playsinline: 1,
        showinfo: 0,
        iv_load_policy: 3
      }
    });

    wrap._ytPlayer = player;
    wrap.classList.add("playing");

    player.on('stateChange', (state) => {
      if (state === 0) { // ended
        wrap.classList.remove("playing");
        wrap._videoInitialized = false;
        wrap._ytPlayer = null;
      }
    });
  }

  // Self-hosted
  if (hosted) {
    const videoEl = wrap.querySelector("video");
    if (!videoEl) return;

    wrap.classList.add("playing");
    videoEl.muted = muted;
    videoEl.hidden = false;
    videoEl.play().catch(() => {
      // Se il browser blocca anche con muted, non fa nulla
    });

    videoEl.onended = () => {
      wrap.classList.remove("playing");
      wrap._videoInitialized = false;
      videoEl.hidden = true;
    };
  }
};

const stopVideo = (wrap) => {
  const provider = wrap.dataset.videoProvider;
  const hosted   = wrap.dataset.videoHosted === "true";

  if (provider === "youtube" && wrap._ytPlayer) {
    wrap._ytPlayer.stopVideo();
    wrap._ytPlayer = null;
  }

  if (hosted) {
    const videoEl = wrap.querySelector("video");
    if (videoEl) {
      videoEl.pause();
      videoEl.currentTime = 0;
      videoEl.hidden = true;
    }
  }

  wrap.classList.remove("playing");
  wrap._videoInitialized = false;
};

const toggleVolume = (wrap) => {
  const isUnmuted = wrap.classList.contains("is-unmuted");
  const provider  = wrap.dataset.videoProvider;
  const hosted    = wrap.dataset.videoHosted === "true";

  if (provider === "youtube" && wrap._ytPlayer) {
    if (isUnmuted) {
      wrap._ytPlayer.mute();
    } else {
      wrap._ytPlayer.unMute();
    }
  }

  if (hosted) {
    const videoEl = wrap.querySelector("video");
    if (videoEl) videoEl.muted = isUnmuted;
  }

  wrap.classList.toggle("is-unmuted");
};

// Gestione click (play, stop, volume) — delegazione globale, un solo listener
document.addEventListener("click", (e) => {
  // Stop
  const stopBtn = e.target.closest(".block-media__stop");
  if (stopBtn) {
    const wrap = stopBtn.closest(".block-media__video");
    if (wrap) {
      stopVideo(wrap);
      wrap.classList.remove("is-unmuted");
    }
    return;
  }

  // Volume toggle
  const volBtn = e.target.closest(".block-media__volume");
  if (volBtn) {
    const wrap = volBtn.closest(".block-media__video");
    if (wrap) toggleVolume(wrap);
    return;
  }

  // Play con audio (click utente)
  const wrap = e.target.closest(".block-media__video");
  if (wrap && !wrap.classList.contains("playing")) {
    initVideo(wrap, { muted: false });
  }
});

// Autoplay quando la sezione entra nel viewport (muted per policy browser)
document.arrive('.block-media', { existing: true }, function () {
  const section = this;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        section.querySelectorAll('.block-media__video').forEach(wrap => {
          initVideo(wrap, { muted: true });
        });
        observer.unobserve(section);
      }
    });
  }, { threshold: 0.3 });

  observer.observe(section);
});
